import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DisconnectGlyph = /*#__PURE__*/createElement("g", {
  id: "disconnected"
}, /*#__PURE__*/createElement("path", {
  d: "M42,69.79A27.79,27.79,0,1,1,69.79,42,27.83,27.83,0,0,1,42,69.79Zm0-53.58A25.79,25.79,0,1,0,67.79,42,25.82,25.82,0,0,0,42,16.21Z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,62.25A20.25,20.25,0,1,1,62.25,42,20.27,20.27,0,0,1,42,62.25Zm0-37.5A17.25,17.25,0,1,0,59.25,42,17.27,17.27,0,0,0,42,24.75Z"
}));
const Disconnect = createSvg({
  name: 'disconnect',
  path: DisconnectGlyph
});

export default Disconnect;
export { DisconnectGlyph };
